import React from "react";
import ReactApexChart from "react-apexcharts";

const StudentsPerUniversityChart = ({ data = [], categories = [] }) => {
  const series = [
    {
      name: "عدد الطلاب",
      data: data, 
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "7%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val} طالب`,
      style: {
        fontSize: "12px",
      },
    },
    xaxis: {
      categories: categories,
      title: {
        text: "الجامعة",
        style: {
          fontSize: "14px",
          fontFamily: "Cairo",
        },
      },
      labels: {
        style: {
          fontFamily: "Cairo",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => `${val}`,
      },
      title: {
        // text: "عدد الطلاب",
        style: {
          fontSize: "14px",
          fontFamily: "Cairo",
        },
      },
    },
    colors: ["#282562"],
    tooltip: {
      y: {
        // formatter: (val) => `${val} طالب`,
      },
    },
  };

  return (
    <div className="card mt-4 p-3">
        <h5 className="mb-3">عدد الطلاب في الجامعات</h5>
      <ReactApexChart options={options} series={series} type="bar" height={350} />
    </div>
  );
};

export default StudentsPerUniversityChart;


